const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Al Mouj",
  snitch: {
    enabled: true,
    devicePrefix: "amm-sec-nuc"
  }

  // not currently using webfeed
  //   webfeedDebuggerWebsiteUrl:
  //     "https://www.riverlea.com.au/for-sale/#/masterplan",
  //   webfeedConfig: {
  //     mode: "masterplan", // masterplan, feed
  //     type: "land" // land, packages, dwellings etc
  //   }

  // add other conf items below if needed
};
